import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { SiteLayout } from "@/components/SiteLayout";
import Home from "@/pages/Home";
import HowItWorksPage from "@/pages/HowItWorksPage";
import ApplicationsPage from "@/pages/ApplicationsPage";
import WorkMethodPage from "@/pages/WorkMethodPage";
import FAQPage from "@/pages/FAQPage";
import QuotePage from "@/pages/QuotePage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";
import ThanksPage from "@/pages/ThanksPage";
import NotFound from "@/pages/NotFound";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const UtmCapture = () => {
  useEffect(() => {
    if (localStorage.getItem("bpr_utm")) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {
      source: params.get("utm_source") || "",
      medium: params.get("utm_medium") || "",
      campaign: params.get("utm_campaign") || "",
      term: params.get("utm_term") || "",
      content: params.get("utm_content") || "",
      landing_page: window.location.pathname,
      referrer: document.referrer || "",
      date: new Date().toISOString(),
    };
    localStorage.setItem("bpr_utm", JSON.stringify(utm));
  }, []);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <UtmCapture />
        <SmoothScroll />
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/hoe-het-werkt" element={<HowItWorksPage />} />
            <Route path="/toepassingen" element={<ApplicationsPage />} />
            <Route path="/werkwijze" element={<WorkMethodPage />} />
            <Route path="/veelgestelde-vragen" element={<FAQPage />} />
            <Route path="/offerte" element={<QuotePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacyverklaring" element={<PrivacyPage />} />
            <Route path="/cookieverklaring" element={<CookiesPage />} />
            <Route path="/bedankt" element={<ThanksPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
